import Content from '@ui/components/Content/Content';
import styles from '@ui/components/Table/Table.module.scss';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Table = ({
  children,
  isComparable = false,
  withParser = false,
  blueHeading,
  className = null,
}) => (
  <div
    className={classNames(
      styles.container,
      {
        [styles.comparable]: isComparable,
        [styles.blueHeading]: blueHeading,
      },
      className,
    )}
  >
    {isComparable && (
      <div className={styles.contentCopy}>
        <Content noSpacing withParser={withParser}>
          {children}
        </Content>
      </div>
    )}
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <Content as="div" noSpacing withParser={withParser}>
          {children}
        </Content>
      </div>
    </div>
  </div>
);

Table.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isComparable: PropTypes.bool,
  withParser: PropTypes.bool,
};

export default Table;
